import apiClient from '../core/axios';

export interface StartSessionInput { pageContextStart?: string; }
export interface PostMessageInput { sessionId: string; message: string; pageContext?: string; userLanguage?: string; }
export interface ExecuteActionInput {
  sessionId: string; actionId: string; params: Record<string, any>;
  previewToken: string; destructiveTypedName?: string;
}

export interface PreviewSummary { summary: string; affectedCount?: number; warnings?: string[]; }

export type PlanOutput =
  | { kind: 'text'; text: string }
  | { kind: 'preview'; actionId: string; params: Record<string, any>; preview: PreviewSummary; previewToken: string }
  | { kind: 'denied'; actionId: string; reason: string }
  | { kind: 'error'; message: string };

export type ExecuteOutput =
  | { kind: 'result'; summary: string; entityType?: string; entityId?: string; data?: any }
  | { kind: 'token-invalid'; reason: string }
  | { kind: 'denied' }
  | { kind: 'error'; message: string };

export const consoleAiService = {
  async startSession(input: StartSessionInput): Promise<{ sessionId: string }> {
    const { data } = await apiClient.post('/console-ai/sessions', input);
    return data?.data ?? data;
  },
  async postMessage(input: PostMessageInput): Promise<PlanOutput> {
    const { data } = await apiClient.post('/console-ai/messages', input);
    return data?.data ?? data;
  },
  async executeAction(input: ExecuteActionInput): Promise<ExecuteOutput> {
    const { data } = await apiClient.post('/console-ai/actions/execute', input);
    return data?.data ?? data;
  },
};
